module.exports = __webpack_public_path__ + "img/000.faa80c39.svg";